export default () => ({
  online: true,
  isApiKeyValid: true
})
